/* AMPD Product Promotion: add-to-cart hook + countdown.

   Standalone from bundle-upgrade.js by design - the promo card is where
   experiments happen and the pack list should never be affected by them.

   Add to cart: ticking the box is a selection only. When the main product form
   fires on:cart:add, the ticked promo variant is added to the cart alongside
   the product and the cart drawer is refreshed. The discount itself (e.g. a
   Buy X Get Y automatic discount) is applied by Shopify in the cart; nothing
   here changes prices.

   Countdown: reads the end time from data-ends (ms since epoch, rendered by
   Liquid from the "ends" setting) and ticks down days / hours / minutes /
   seconds. At zero it hides the timer and the whole card, so an expired offer
   can't keep advertising itself until the next page load. */
(function () {
  /* ---------- add to cart ---------- */
  function selectedIds() {
    var ids = [];
    document.querySelectorAll('[data-ampd-promo-add]:checked').forEach(function (cb) {
      if (!cb.disabled && cb.dataset.variantId) ids.push(Number(cb.dataset.variantId));
    });
    return ids;
  }

  var busy = false;
  function onMainAdd(e) {
    var pf = e.target && e.target.closest ? e.target.closest('product-form') : null;
    if (!pf || pf.closest('quick-add-drawer')) return;
    var ids = selectedIds();
    if (!ids.length || busy) return;
    busy = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    })
      .then(function () { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); })
      .catch(function () {})
      .finally(function () { busy = false; });
  }
  document.addEventListener('on:cart:add', onMainAdd);
  document.addEventListener('on:line-item:change', onMainAdd);

  /* ---------- countdown ---------- */
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function startTimer(card) {
    var ends = Number(card.getAttribute('data-ends'));
    var timer = card.querySelector('[data-ampd-promo-timer]');
    if (!ends || !timer) return;

    var d = timer.querySelector('[data-unit="d"]');
    var h = timer.querySelector('[data-unit="h"]');
    var m = timer.querySelector('[data-unit="m"]');
    var s = timer.querySelector('[data-unit="s"]');
    var wrap = card.closest('.ampd-promo-wrap') || card;

    function tick() {
      var left = ends - Date.now();
      if (left <= 0) {
        // Offer over: take the whole card away rather than show 00:00:00:00
        // next to "FREE", which would read as a live offer that doesn't work.
        wrap.hidden = true;
        clearInterval(iv);
        return;
      }
      var sec = Math.floor(left / 1000);
      var days = Math.floor(sec / 86400); sec -= days * 86400;
      var hrs = Math.floor(sec / 3600); sec -= hrs * 3600;
      var mins = Math.floor(sec / 60); sec -= mins * 60;
      d.textContent = String(days);
      h.textContent = pad(hrs);
      m.textContent = pad(mins);
      s.textContent = pad(sec);
    }
    tick();
    var iv = setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('[data-ampd-promo][data-ends]').forEach(startTimer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
